import sensorLog from "@/utils/sensorLog"

export var LogLevel
;(function(LogLevel) {
  LogLevel[(LogLevel["VERBOSE"] = 0)] = "VERBOSE"
  LogLevel[(LogLevel["LOG"] = 1)] = "LOG"
  LogLevel[(LogLevel["INFO"] = 2)] = "INFO"
  LogLevel[(LogLevel["WARN"] = 3)] = "WARN"
  LogLevel[(LogLevel["ERROR"] = 4)] = "ERROR"
  LogLevel[(LogLevel["FATAL"] = 5)] = "FATAL"
  LogLevel[(LogLevel["SILENT"] = Infinity)] = "SILENT"
})(LogLevel || (LogLevel = {}))

export const LogLevels = {
  VERBOSE: LogLevel.VERBOSE,
  LOG: LogLevel.LOG,
  INFO: LogLevel.INFO,
  WARN: LogLevel.WARN,
  ERROR: LogLevel.ERROR,
  SILENT: LogLevel.SILENT
}
export default class ConsoleLogger {
  /**
   * ConsoleLogger构造函数
   *
   * @param   {string}  prefix  Logger输出前缀
   *
   * @return  {ConsoleLogger}
   */
  constructor(prefix) {
    this.Levels = LogLevels
    this.level = LogLevel.VERBOSE
    this.prefix = "ocfe"
    this.enabled = true
    this.logColor = bold("#bbbbbb", 12)
    this.infoColor = bold("#2196f3", 12)
    this.warnColor = bold("#ff00ff", 12)
    this.errorColor = bold("#e91e63", 12)
    this.fatalColor = bold("#9a0101", 13)
    this.setPrefix(prefix)
  }
  setPrefix(prefix) {
    this.prefix = `%c[${prefix}]`
  }
  enable(level = this.level) {
    this.level = level
    this.enabled = true
  }
  disable() {
    this.enabled = false
  }
  /**
   * 设置日志等级，只有当日志函数高于当前级别才会产生输出
   *
   * @param   {LogLevel}  level
   *
   * @return  {void}
   */
  setLevel(level) {
    this.level = level
  }
  // console.log("this.prefix---->",this.prefix)
  // console.log("str---->", str)
  // console.log("logData--->", logData)
  debug(title, ...args) {
    if (!this.enabled || this.level > LogLevel.VERBOSE) return
    console.log(`${this.prefix} ${title}`, this.logColor, ...args)
  }
  log(title, ...args) {
    // if (!this.enabled || this.level > LogLevel.LOG) return
    console.log(`${this.prefix} ${title}`, this.logColor, ...args)
    sensorLog.track(`${title}`, "init", JSON.stringify(...args))
  }
  info(title, ...args) {
    if (!this.enabled || this.level > LogLevel.INFO) return
    console.info(`${this.prefix} ${title}`, this.infoColor, ...args)
    sensorLog.track(`${title}`, "successed", JSON.stringify(...args))
  }
  warn(title, ...args) {
    if (!this.enabled || this.level > LogLevel.WARN) return
    console.warn(`${this.prefix} ${title}`, this.warnColor, ...args)
    sensorLog.track(`${title}`, "failed", JSON.stringify(...args))
  }
  error(title, ...args) {
    if (!this.enabled || this.level > LogLevel.ERROR) return
    console.error(`${this.prefix} ${title}`, this.errorColor, ...args)
    sensorLog.track(`${title}`, "failed", JSON.stringify(...args))
  }
  fatal(title, ...args) {
    if (!this.enabled || this.level > LogLevel.FATAL) return
    console.error(`${this.prefix} ${title}`, this.fatalColor, ...args)
    sensorLog.track(`${this.prefix}`, "failed", JSON.stringify(...args))
  }
  toString() {
    return `#<ConsoleLogger pefix="${this.prefix}" level="${this.level}">`
  }
  // sensorLog.track(`${event_type}`, "init", logData)
}
function bold(hex, x) {
  return `color:${hex};font-size:${x}px;font-weight:bold;`
}
